import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { iotDevicesApi } from '../services/iotDevicesApi'
import { getTenantId } from '../config/tenant'

export const useDevices = () => {
  const tenantId = getTenantId()
  return useQuery({
    queryKey: ['devices', tenantId],
    queryFn: () => iotDevicesApi.getByTenant(tenantId),
    enabled: !!tenantId,
    refetchInterval: () =>
      typeof document !== 'undefined' && document.hidden ? false : 60000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  })
}

export const useCreateDevice = () => {
  const queryClient = useQueryClient()
  const tenantId = getTenantId()
  return useMutation({
    mutationFn: (payload) => {
      if (!tenantId) throw new Error('Tenant não encontrado. Faça login novamente.')
      return iotDevicesApi.create(tenantId, payload)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['devices', tenantId] })
    },
  })
}

export const useUpdateDevice = () => {
  const queryClient = useQueryClient()
  const tenantId = getTenantId()
  return useMutation({
    mutationFn: ({ id, payload }) => iotDevicesApi.update(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['devices', tenantId] })
    },
  })
}

export const useEnableWebDevice = () => {
  const queryClient = useQueryClient()
  const tenantId = getTenantId()
  return useMutation({
    mutationFn: (devEui) => iotDevicesApi.enableWebDevice(devEui),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['devices', tenantId] })
    },
  })
}

export const useRegenerateWebDeviceToken = () => {
  const queryClient = useQueryClient()
  const tenantId = getTenantId()
  return useMutation({
    mutationFn: (devEui) => iotDevicesApi.regenerateWebDeviceToken(devEui),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['devices', tenantId] })
    },
  })
}

export const useDisableWebDevice = () => {
  const queryClient = useQueryClient()
  const tenantId = getTenantId()
  return useMutation({
    mutationFn: (devEui) => iotDevicesApi.disableWebDevice(devEui),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['devices', tenantId] })
    },
  })
}

export const useDeleteDevice = () => {
  const queryClient = useQueryClient()
  const tenantId = getTenantId()
  return useMutation({
    mutationFn: (id) => iotDevicesApi.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['devices', tenantId] })
    },
  })
}

// --- Destinatários de alarme por WhatsApp ---
export const useAlarmRecipients = (deviceId) =>
  useQuery({
    queryKey: ['alarmRecipients', deviceId],
    queryFn: () => iotDevicesApi.getAlarmRecipients(deviceId),
    enabled: !!deviceId,
  })

export const useAlarmRecipientCandidates = () => {
  const tenantId = getTenantId()
  return useQuery({
    queryKey: ['alarmRecipientCandidates', tenantId],
    queryFn: () => iotDevicesApi.getAlarmRecipientCandidates(tenantId),
    enabled: !!tenantId,
  })
}

export const useSetAlarmRecipients = (deviceId) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (tenantUserIds) => iotDevicesApi.setAlarmRecipients(deviceId, tenantUserIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['alarmRecipients', deviceId] })
    },
  })
}

